'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _i18nextXhrBackend = _interopRequireDefault(require("i18next-xhr-backend"));

var _i18nextBrowserLanguagedetector = _interopRequireDefault(require("i18next-browser-languagedetector"));

var _conf = _interopRequireDefault(require("./conf/conf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_i18next.default.use(_i18nextXhrBackend.default).use(_i18nextBrowserLanguagedetector.default).init(_conf.default.i18n);

var _default = _i18next.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/i18n/index.js
// module id = 638
// module chunks = 0